import jwtDecode from 'jwt-decode';
import ITokenDecoded from '../common/interfaces/ITokenDecoded';
import IIdentityTokenDecoded from '../common/interfaces/IIdentityTokenDecoded';

export const decodeToken = (token: string) => jwtDecode<ITokenDecoded>(token);

export const decodeIdentityToken = (token: string) =>
    jwtDecode<IIdentityTokenDecoded>(token);
